import { FC, type JSX } from 'react';

import { Modal } from '@payaca/ambrosia';
import { Supplier } from '@payaca/types/supplierTypes';
import CreateEditSupplierControl from '../createEditSupplierControl/CreateEditSupplierControl';
import './CreateEditSupplierModal.sass';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onPersistSupplierSuccess?: (supplierId: number) => void;
  supplier?: Supplier;
};
const CreateEditSupplierModal: FC<Props> = ({
  isOpen,
  onClose,
  onPersistSupplierSuccess,
  supplier,
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      className="create-edit-supplier-modal"
      title={supplier?.id ? 'Edit supplier' : 'Create supplier'}
      onClose={onClose}
    >
      <Modal.Body>
        <CreateEditSupplierControl
          supplier={supplier}
          onPersistSupplierSuccess={(supplierId: number) => {
            onClose();
            onPersistSupplierSuccess?.(supplierId);
          }}
        />
      </Modal.Body>
    </Modal>
  );
};
export default CreateEditSupplierModal;
